<template>
  <div class="box-pager">
    <div
      class="icon double-left"
      :class="{ 'disabled': currentPageCount === 1}"
      @click.stop="handlePagerClick(1)"
    >
      <i class="far fa-chevron-double-left" />
    </div>
    <div
      class="icon left"
      :class="{ 'disabled': currentPageCount === 1}"
      @click.stop="handlePagerClick(currentPageCount - 1)"
    >
      <i class="far fa-chevron-left" />
    </div>
    <div class="page-numbers">
      <SquareBox
        v-for="(_, index) in displayPages" :key="index"
        class="square-box"
        :class="{
          'active': currentPageCount === _,
        }"
        @handleSquareBoxClick="handleSquareBtnClick(_)"
      >
        <span
          class="text"
        >
          {{_}}
        </span>
      </SquareBox>
    </div>
    <div
      class="icon right"
      :class="{ 'disabled': isNextDisabled}"
      @click.stop="handlePagerClick(currentPageCount + 1)"
    >
      <i class="far fa-chevron-right" />
    </div>
    <div
      class="icon double-right"
      :class="{ 'disabled': isNextDisabled}"
      @click.stop="handlePagerClick(totalPageCount)"
    >
      <i class="far fa-chevron-double-right" />
    </div>
  </div>
</template>

<script>
import SquareBox from '@/components/atoms/SquareBox.vue';

export default {
  name: 'BoxPager',

  components: {
    SquareBox,
  },

  props: {
    totalPageCount: {
      type: Number,
      default: 1,
    },
    currentPageCount: {
      type: Number,
      default: 1,
    },
    dispBoxCount: {
      type: Number,
      default: 5,
    },
    dotIndexNumber: {
      type: Number,
      default: 3,
    },
    pages: {
      type: Array,
      default: () => ([]),
    },
  },

  computed: {
    restSquareBoxCount() {
      return this.totalPageCount - this.currentPageCount + 1;
    },
    pagerLoopCount() {
      if (this.totalPageCount > this.dispBoxCount) {
        return this.dispBoxCount;
      }
      return this.totalPageCount;
    },
    isPrevDisabled() {
      return this.currentPageCount === 1;
    },
    isNextDisabled() {
      return this.currentPageCount === this.totalPageCount;
    },
    displayPages() {
      const isMobile = window.innerWidth <= 480;
      if (isMobile) {
        const visibleCount = 5;
        const half = Math.floor(visibleCount / 2);
        let start = this.currentPageCount - half;
        let end = this.currentPageCount + half;
        // 範囲調整
        if (start < 1) {
          end += 1 - start;
          start = 1;
        }
        if (end > this.totalPageCount) {
          start -= end - this.totalPageCount;
          end = this.totalPageCount;
        }
        start = Math.max(start, 1);
        // console.log('start', start);
        // console.log('end', end);
        // 実ページ番号を生成
        const pages = [];
        for (let i = start; i <= end; i += 1) {
          pages.push(i);
        }
        // console.log('pages', pages);
        return pages;
      }
      const maxCount = 11;
      const half = Math.floor(maxCount / 2);
      let start = this.currentPageCount - half;
      let end = this.currentPageCount + half;

      if (start < 1) {
        end += 1 - start;
        start = 1;
      }
      if (end > this.totalPageCount) {
        start -= end - this.totalPageCount;
        end = this.totalPageCount;
      }
      start = Math.max(start, 1);

      const pages = [];
      for (let i = start; i <= end; i += 1) {
        pages.push(i);
      }
      return pages;
    },
  },

  methods: {
    handlePagerClick(pageNumber) {
      const outsideRange = pageNumber < 1 || this.totalPageCount < pageNumber;
      const startOrEnd = pageNumber === this.currentPageCount;
      if (outsideRange || startOrEnd) {
        return;
      }
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
      this.$emit('handlePagerClick', pageNumber);
    },
    handleSquareBtnClick(index) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
      this.$emit('handleSquareBtnClick', index);
    },
  },
};
</script>

<style lang="scss" scoped>
.box-pager{
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: $lightColor;
  padding: 25px 0;
  .fa-chevron-double-left,
  .fa-chevron-left,
  .fa-chevron-double-right,
  .fa-chevron-right{
    font-size: 18px;
    line-height: 1.5;
    color: black;
  }
  .icon{
    cursor: pointer;
    &.disabled{
      opacity: 0.2;
      pointer-events: none;
    }
  }
  .icon.left{
    margin-left: 20px;
  }
  .page-numbers{
    display: flex;
    margin-left: 25px;
    .square-box{
      width: 30px;
      height: 30px;
      cursor: pointer;
      margin: 0 20px;
      .text{
        font-family: $notoSans;
        font-size: 14px;
        line-height: 27px;
        color: #425887dc;
        font-weight: bold;
      }
      &.active{
        background-color: rgba(150, 148, 255, 0.158);
        border-radius: 50%;
        cursor: auto;
        .text{
          font-size: 18px;
          font-weight: bolder;
          color: $mainColor;
        }
      }
      & + .square-box{
        margin-left: 10px;
        @media screen and (max-width: $mobileWidth) {
        margin-left: 5px;
        }
      }
    }
  }
  .icon.right{
    margin-left: 25px;
  }
  .icon.double-right{
    margin-left: 20px;
  }
}
@media screen and (max-width: $tabletWidth) {
  .box-pager {
    padding: 5px 0;
    margin: 0 -20px;
    .page-numbers{
      .square-box{
        width: 25px;
        height: 25px;
        margin: 0 5px;
        .text{
          font-size: 14px;
        }
      }
    }
  }
}
</style>
